<template>
  <div class="row">
    <div class="col col-lg-6 col-md-6 col-sm-12">
      <card-data v-bind:data="connects.total" v-bind:title="connects.title"/>
    </div>
    <div class="col col-lg-6 col-md-6 col-sm-12">
      <card-data v-bind:data="runners.total" v-bind:title="runners.title"/>
    </div>
  </div>
</template>

<script>
import cardData from './cardData.vue';

export default {
  name: "cards",
  components: {
    cardData
  },
  props:{
    connects: Object,
    runners: Object
  },
  data(){
    return {
    }
  }
}
</script>

<style scoped>

</style>